//
// wizard.js
// 
import { Tab } from 'bootstrap';

const toggles = document.querySelectorAll('[data-toggle="wizard"]');

toggles.forEach(toggle => {
  toggle.addEventListener('click', function(e) {
    e.preventDefault();

    // Toggle new tab
   // const tab = new Tab(toggle);
    var tab = new Tab(toggle) 
    console.log(tab);
    tab.show();
    console.log("after show");
    // Remove active state
    toggle.classList.remove('active');
  });
});
